import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center px-5 py-32 text-center">
      <div className="font-mono text-7xl font-bold text-brand-blue">404</div>
      <h1 className="mt-6 font-heading text-3xl font-bold text-brand-ink">Page not found</h1>
      <p className="mt-3 text-brand-muted">
        The page you are looking for does not exist or has moved.
      </p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="mt-8 inline-flex items-center gap-2 bg-brand-blue px-6 py-3 text-sm font-semibold text-white hover:bg-brand-bluedark"
      >
        <ArrowLeft className="h-4 w-4" /> Back to Home
      </Link>
    </div>
  );
}
